// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Wk-z","tupacHeader":"Xk-z","tupacHeader2":"Yk-z","tupacMenu":"Zk-z","tupacMenu2":"_k-z","tupacMain":"al-z","tupacMain2":"bl-z"};